module.exports = __webpack_public_path__ + "static/img/sf-item-01.70d0a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-01.png
// module id = yxjA
// module chunks = 2